var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultAvatarUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EBF3FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2548_81600",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#EBF3FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2548_81600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6318 16.3218C26.6318 19.8133 23.7205 22.6437 20.1293 22.6437C16.5381 22.6437 13.6268 19.8133 13.6268 16.3218C13.6268 12.8304 16.5381 10 20.1293 10C23.7205 10 26.6318 12.8304 26.6318 16.3218Z",
    fill: "#C2DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1293 26.4368C13.8447 26.4368 8.75 31.39 8.75 37.5V41.875H31.5086V37.5C31.5086 31.39 26.4139 26.4368 20.1293 26.4368Z",
    fill: "#C2DAFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultAvatarUser);
export default __webpack_public_path__ + "static/media/DefaultAvatarUser.2a738f630e4163409991ec8479bbc2ea.svg";
export { ForwardRef as ReactComponent };